import { useLayoutStore, LayoutId } from '@/store/layout';
import { RouteLocationNormalized } from 'vue-router';

export default function (to: RouteLocationNormalized) {
  const layoutStore = useLayoutStore();
  layoutStore.setLayout(to.meta.layout as LayoutId);
  return true;
}
